<template>
  <section>
    <div class="tip" style="margin:25px 0 0 40px">* 提交资料</div>
    <ul class="project-info-list">
      <li>
        <label>调动人员：</label>
        <div class="info-item">
          <user-info :userData='form.userArchives.userVO'></user-info>
        </div>
      </li>
      <li>
        <label>调动时间：</label>
        <div class="info-item">{{ form.transferTime }}</div>
      </li>
      <li class="block">
        <label>调出公司/部门/职位：</label>
        <div class="info-item">{{ form.outCompany.name+" / "+form.outDep.name+" / "+form.outPosition }}
        </div>
      </li>
      <li class="block">
        <label>调入公司/部门/职位：</label>
        <div class="info-item">{{ form.inCompany.name+" / "+form.inDep.name+" / "+form.inPosition }}
        </div>
      </li>

      <li>
        <label>调动填表人：</label>
        <user-info :userData='form.flow.creator'></user-info>
      </li>
      <li class="block intro-box">
        <label>调动原因：</label>
        <div class="info-item">{{ form.reason }}</div>
      </li>
    </ul>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['form', 'userData'],
    components: {
      UserInfo,
    },
    data() {
      return {}
    },
    mounted() {},
    methods: {
      // 时间截取
      getSTime(time) {
        let _t = time.split(":")
        return _t[0] + ":" + _t[1]
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/transferApply.vue